import React from 'react';
import SupportIcon from '../icons/SupportIcon';

interface Props {
  isOpen: boolean;
  unreadCount: number;
  onClick: () => void;
}

/**
 * Floating action button (FAB) для открытия чата поддержки.
 * Меняет вид при открытом окне (показывает иконку «свернуть»).
 */
const SupportChatLauncher: React.FC<Props> = ({ isOpen, unreadCount, onClick }) => {
  return (
    <button
      type="button"
      className={`sc-launcher ${isOpen ? 'is-open' : ''} ${unreadCount > 0 && !isOpen ? 'has-unread' : ''}`}
      onClick={onClick}
      aria-label={isOpen ? 'Свернуть чат поддержки' : 'Открыть чат поддержки'}
      aria-expanded={isOpen}
      title={isOpen ? 'Свернуть' : 'Чат с поддержкой'}
    >
      <span className="sc-launcher__halo" aria-hidden="true" />
      <span className="sc-launcher__icons" aria-hidden="true">
        <span className="sc-launcher__icon sc-launcher__icon--chat">
          <SupportIcon size={26} strokeWidth={2} />
        </span>
        <span className="sc-launcher__icon sc-launcher__icon--close">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </span>
      </span>

      {unreadCount > 0 && !isOpen && (
        <span className="sc-launcher__badge" aria-label={`${unreadCount} новых сообщений`}>
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}

      <span className="sc-launcher__label" aria-hidden="true">
        Поддержка
      </span>
    </button>
  );
};

export default SupportChatLauncher;
